import { render } from "./RetailView.vue?vue&type=template&id=e627d27e&scoped=true"
import script from "./RetailView.vue?vue&type=script&lang=js"
export * from "./RetailView.vue?vue&type=script&lang=js"

import "./RetailView.vue?vue&type=style&index=0&id=e627d27e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e627d27e"]])

export default __exports__